/**
 * Folder entry that sends finished/terminal items to the archive screen,
 * keeping the main list focused on what's active.
 */
export function ArchiveFolder({
  label,
  count,
  onClick,
}: {
  label: string;
  count: number;
  onClick: () => void;
}): JSX.Element {
  return (
    <button
      type="button"
      onClick={onClick}
      className="mt-2 flex w-full items-center gap-3 rounded-card bg-tg-bg-secondary p-4 text-left"
    >
      <span className="text-xl" aria-hidden>
        📁
      </span>
      <span className="flex-1 font-medium text-tg-text">{label}</span>
      <span className="rounded-pill bg-tg-bg px-2 py-0.5 text-xs text-tg-hint">{count}</span>
      <span className="text-tg-hint" aria-hidden>
        ›
      </span>
    </button>
  );
}
